// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PremiumPlanCollection {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: -20px;
  margin-top: 50px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.groupedPlans {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

@media (max-width: 849px) {
  .groupedPlans:nth-child(2) {
    margin-top: 50px;
  }
}
@media (max-width: 1139px) {
  .groupedPlans.--free {
    margin-top: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/client/components/Subscription/PremiumPlans/PremiumPlanCollection.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,mBAAA;MAAA,eAAA;AACF;;AAEA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;AACF;;AAEA;EACE;IACE,gBAAA;EACF;AACF;AAEA;EAEI;IACE,gBAAA;EADJ;AACF","sourcesContent":[".PremiumPlanCollection {\n  display: flex;\n  margin-left: -20px;\n  margin-top:50px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.groupedPlans {\n  display: flex;\n}\n\n@media (max-width: 849px){\n  .groupedPlans:nth-child(2) {\n    margin-top: 50px;\n  }\n}\n\n@media (max-width: 1139px){\n  .groupedPlans {\n    &.--free {\n      margin-top: 50px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
